module.exports = __webpack_public_path__ + "img/ent-loc-scan.655eed9e.png";